import { routes } from './routes';
import { getAuthHeader, getCookie, getUserFromLS } from '@/helpers/userHelper';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import { store } from '../store';
import { CONSTANTS } from '@/constants/guide';
import {
  handleOnPageRequiresAuth,
  handleOnPublicPage,
  setMetaTags
} from '@/modules/router/middlewares';

Vue.use(VueRouter);
Vue.use(VueResource);

const router = new VueRouter({
  base: process.env.NODE_ENV === 'production' ? '/interface/' : '/',
  routes,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  //Set meta tags of the new page First
  setMetaTags(to);
  const pageRequiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const token = getAuthHeader();
  const user = getUserFromLS();
  let willRedirect;

  if (pageRequiresAuth) {
    willRedirect = handleOnPageRequiresAuth(user, next, to, from);
  } else {
    willRedirect = handleOnPublicPage(token, next, to);
  }

  if (willRedirect && token !== '') {
    store.dispatch('checkOutModule/getCartContent', getCookie('client_id'));
  }
});

router.afterEach((to, from) => {
  window.dataLayer?.push({ event: 'vp_interface', page: to.name });

  store.commit('homeModule/setTourData', {});
  if (to.matched.some(record => record.meta?.hasTour === true)) {
    store.dispatch('homeModule/getGuidedTourData', {
      pageCode: 'vet_interface_' + to.name,
      sectionsIds: CONSTANTS.GUIDED_TOUR.SECTIONS[to.name]
    });
  }

  if (to.fullPath === '/faq') {
    const sessionId = getCookie('om_frontend');

    location.href = 'https://rationsberechnung.de/faq?sessionId='+sessionId
  }
});
export default router;
